// removed by extract-text-webpack-plugin
module.exports = {"wrap":"common-TipPop-wrap","icon":"common-TipPop-icon","blueIcon":"common-TipPop-blueIcon","tipPop":"common-TipPop-tipPop","rightTipPop":"common-TipPop-rightTipPop","bottomTipPop":"common-TipPop-bottomTipPop","bottomRightTipPop":"common-TipPop-bottomRightTipPop","qestion":"common-TipPop-qestion","answer":"common-TipPop-answer","tooltip":"common-TipPop-tooltip","rightTooltip":"common-TipPop-rightTooltip","btn":"common-TipPop-btn","arrow":"common-TipPop-arrow","bottomArrow":"common-TipPop-bottomArrow","bottomRightArrow":"common-TipPop-bottomRightArrow","rightArrow":"common-TipPop-rightArrow"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/TipPop/index.css
// module id = 1777
// module chunks = 0